define('olarkUtils',['require'],function (require) {

    // ── CSS-based Olark hide — injected once, survives Olark re-renders ──
    // Olark renders its button inside an iframe with id="olark-container".
    // Hiding it via CSS is the only bulletproof approach because Olark
    // re-draws its button after every page navigation, overwriting any
    // api.button.hide() calls we make.
    var _styleTag = null;

    function hideOlarkViaCss() {
        if (_styleTag) return; // already injected
        _styleTag = document.createElement('style');
        _styleTag.id = 'ai-hide-olark';
        _styleTag.innerHTML = '#olark-container, #olark-wrapper, .olark-launch-button { display: none !important; }';
        document.head.appendChild(_styleTag);
        console.log('[olarkUtils] Olark hidden via CSS');
    }

    function showOlarkViaCss() {
        var existing = document.getElementById('ai-hide-olark');
        if (existing) {
            existing.parentNode.removeChild(existing);
            _styleTag = null;
            console.log('[olarkUtils] Olark CSS hide removed — Olark visible');
        }
    }

    var AI_SERVICE_URL = 'http://localhost:4000';
    var _aiStatusChecked = false;  // only fetch once per page load

    function applyOlarkVisibility() {
        if (_aiStatusChecked) return;
        _aiStatusChecked = true;

        fetch(AI_SERVICE_URL + '/public/ai-status')
            .then(function (res) { return res.json(); })
            .then(function (json) {
                if (json.aiEnabled === true) {
                    hideOlarkViaCss();
                } else {
                    showOlarkViaCss();
                }
            })
            .catch(function () {
                // Node unreachable — show Olark as safe fallback
                showOlarkViaCss();
                console.warn('[olarkUtils] Could not reach AI service — Olark shown as fallback');
            });
    }

    // Run immediately so CSS is injected before Olark even loads
    applyOlarkVisibility();

    return {
        /**
         * Sets data about the logged in user for olark
         */
        init: function () {
            var olark = window.olark;
            if (olark == null) {
                return;
            }

            var user = window.ServerData.user;
            var un = user != null ? user.UserName : 'Not Logged In';
            olark('api.chat.updateVisitorNickname', { snippet: un });
            olark('api.visitor.updateFullName', { fullName: un });
            if (user != null && user.Email != null) {
                olark('api.visitor.updateEmailAddress', { emailAddress: window.ServerData.user.Email });
            }
        },

        /**
         * Opens the olark chat box
         */
        openChat: function (e) {
            var event = e.original || e.originalEvent || e;
            event.preventDefault();
            window.olark('api.box.expand');
        }
    };
});
